import { API, ApiException, AxiosPromise } from '@/common/utils/base-api';

export const AuthApi = {
    /*
    async initSession() {
        const apiResponse = await API.get("api/auth/initsession");
        return apiResponse;
    },
    */

    refreshToken(): AxiosPromise<any> {
        return API.get("/api/auth/refreshtoken");
    }

    /*
    async refreshToken() {
        const apiResponse = await API.get("api/auth/refreshtoken");
        return apiResponse;
    }*/
};